import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';

i18next
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    debug: process.env.REACT_APP_ENV !== 'production',
    fallbackLng: 'en-US',
    lng: 'en-US',
  });
